var _clipPath, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSl5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 139 48",
    width: 139,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.11328 1.45654h120v46.087h-120z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 28,
    maskUnits: "userSpaceOnUse",
    width: 49,
    x: 17,
    y: 12
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m59.6887 39.499c.1519.0121.3055.0183.4605.0183 3.1469 0 5.698-2.5511 5.698-5.698 0-2.3308-1.3995-4.3347-3.404-5.2173-.3094-5.4205-4.803-9.7207-10.301-9.7207-.5131 0-1.0174.0375-1.5105.1098-2.0242-3.9075-6.105-6.5778-10.8095-6.5778-5.5447 0-10.2231 3.7093-11.6891 8.7818-.554-.1036-1.1254-.1578-1.7095-.1578-5.1031 0-9.24 4.1369-9.24 9.24 0 4.5788 3.3305 8.3798 7.7012 9.1124v.1276h27.2484.009.009 7.5375z",
    fill: "#55b435",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m109.085 15.8774c0-.7977.147-1.3561.442-1.6752s.794-.4787 1.496-.4787h1.388l.156.1556v11.655c0 .351.079.6262.239.8256.168.1915.439.2872.814.2872h1.388c.183.5505.275 1.1169.275 1.6992 0 .1276-.004.2633-.012.4069-.008.1435-.032.2752-.072.3948-.431.0559-.925.1077-1.484.1556-.558.0479-1.077.0718-1.555.0718-1.045 0-1.819-.2593-2.322-.7778-.502-.5265-.753-1.3362-.753-2.4291zm6.342 1.424c.103.4228.155.8416.155 1.2564 0 .4547-.052.8855-.155 1.2924l-4.392-.0718-3.805.0718c-.104-.4069-.156-.8377-.156-1.2924 0-.4148.052-.8336.156-1.2564l3.901.0718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.939 26.6469c.192.5345.288 1.1009.288 1.6992 0 .1276-.008.2632-.024.4068-.008.1436-.028.2752-.06.3949-.343.0558-.738.1077-1.185.1556-.439.0478-.877.0717-1.316.0717-1.037 0-1.779-.2592-2.226-.7778-.447-.5265-.67-1.3362-.67-2.4291v-14.3593l.168-.1675h1.376c.71 0 1.208.1635 1.495.4906.296.3191.443.8775.443 1.6752v11.7149c0 .3669.08.6461.24.8376.159.1914.422.2872.789.2872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.0645 25.9887c0-.9493.2193-1.7271.6581-2.3334.4467-.6142 1.0291-1.0649 1.747-1.3521.718-.2952 1.4878-.4428 2.3095-.4428.3749 0 .8376.012 1.3881.0359.5504.016 1.045.0678 1.4838.1556v2.2735c-.359-.0797-.7818-.1276-1.2684-.1435-.4867-.016-.9015-.024-1.2445-.024-.5584 0-.9653.1476-1.2206.4428-.2552.2951-.3829.6781-.3829 1.1487 0 .343.1037.6302.3111.8616.2075.2313.4946.347.8616.347.4946 0 1.0012-.1755 1.5197-.5265s.9533-.8416 1.3043-1.4718l.5026 2.3094c-.3111.367-.6701.7299-1.077 1.0889-.3988.351-.8655.6462-1.4.8855s-1.1567.359-1.8667.359c-.8217 0-1.4998-.1795-2.0343-.5385-.5344-.3669-.9333-.8256-1.1966-1.3761-.2632-.5584-.3948-1.1248-.3948-1.6992zm10.7336 1.6274c-.0718.3191-.2194.6622-.4428 1.0291-.2154.359-.4387.6262-.6701.8017-.6781-.0239-1.2365-.1874-1.6752-.4906-.4308-.3031-.7619-.6701-.9932-1.1008-.2314-.4388-.379-.8696-.4428-1.2924v-5.1454c0-.5425-.1356-.9453-.4068-1.2086-.2633-.2632-.6701-.3949-1.2206-.3949-.5265 0-1.0969.0838-1.7111.2513-.6063.1596-1.2206.3351-1.8428.5265-.2553-.2872-.4587-.6621-.6103-1.1248-.1436-.4627-.2353-.9134-.2752-1.3522.5265-.2154 1.1089-.4028 1.7471-.5624.6461-.1595 1.2883-.2832 1.9265-.3709.6382-.0878 1.2166-.1317 1.7351-.1317.71 0 1.3841.1317 2.0223.3949.6461.2633 1.1726.6941 1.5795 1.2924.4068.5903.6103 1.3841.6103 2.3812v4.8702c0 .367.0518.6861.1555.9573.1037.2633.2752.4867.5146.6701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.666 27.8315c.0479-.5185.2074-1.0291.4787-1.5316.2792-.5026.5943-.9055.9453-1.2086.6781.4068 1.4439.7698 2.2975 1.0889s1.7032.4786 2.5488.4786c.7339 0 1.2684-.1715 1.6034-.5145.3351-.351.5026-.7379.5026-1.1607 0-.3032-.0997-.6223-.2992-.9573-.1914-.343-.6262-.6542-1.3043-.9334l-2.8838-1.2085c-.9892-.4149-1.8069-.9653-2.453-1.6514-.6382-.686-.9573-1.5955-.9573-2.7282 0-.9813.2552-1.8428.7658-2.5847.5105-.7419 1.2006-1.3203 2.0701-1.7351.8775-.4148 1.8548-.6223 2.9317-.6223 1.1169 0 2.1659.1436 3.1471.4308s1.783.5943 2.4052.9214c-.0319.5185-.1595 1.0251-.3829 1.5197-.2234.4866-.5106.8935-.8616 1.2206-.6142-.2952-1.3242-.5624-2.1299-.8018-.8058-.2393-1.5277-.359-2.1659-.359-.71 0-1.2285.1636-1.5556.4907-.3191.327-.4786.674-.4786 1.041 0 .3351.1116.6302.335.8855.2314.2473.6143.4826 1.1488.706l2.9317 1.2205c.7578.3112 1.404.7021 1.9385 1.1727.5424.4627.9533.9932 1.2325 1.5915.2872.5903.4308 1.2325.4308 1.9266 0 .9573-.2314 1.8188-.6941 2.5846-.4547.7659-1.1447 1.3722-2.0701 1.8189-.9174.4467-2.0702.6701-3.4582.6701-.9733 0-2.0024-.1516-3.0873-.4547-1.0769-.3111-2.0542-.7499-2.9317-1.3163z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.53 37.1371c0 .3529-.049.6669-.147.942-.094.2751-.231.5086-.413.7006-.177.1869-.392.3296-.646.4282-.255.0935-.543.1402-.864.1402-.296 0-.571-.0467-.826-.1402-.249-.0986-.464-.2413-.646-.4282-.181-.192-.324-.4255-.428-.7006-.099-.2751-.148-.5891-.148-.942 0-.4723.083-.8694.249-1.1912.166-.3269.405-.5761.716-.7473.312-.1713.68-.2569 1.106-.2569.4 0 .753.0856 1.059.2569.306.1712.547.4204.724.7473.176.3218.264.7189.264 1.1912zm-2.935 0c0 .2802.029.5164.086.7084.062.1869.158.3296.288.4282.13.0934.299.1401.506.1401.208 0 .374-.0467.498-.1401.13-.0986.224-.2413.281-.4282.062-.192.093-.4282.093-.7084 0-.2803-.031-.5138-.093-.7007-.057-.1868-.151-.327-.281-.4204-.129-.0934-.298-.1401-.506-.1401-.306 0-.529.1064-.669.3192-.135.2076-.203.5216-.203.942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.477 35.0194h1.276l-1.681 2.0397 1.829 2.211h-1.315l-1.737-2.1565v2.1565h-1.16v-4.2507h1.16v2.0631z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.425 34.9337c.57 0 1.006.1246 1.307.3737.307.2439.46.6202.46 1.1289v2.8338h-.81l-.226-.5761h-.031c-.119.1505-.244.275-.373.3737-.125.0986-.27.1686-.436.2101-.161.0468-.361.0701-.6.0701-.249 0-.475-.0467-.677-.1401-.197-.0986-.353-.2465-.467-.4438-.115-.2024-.172-.4567-.172-.7629 0-.4516.159-.7837.475-.9965.317-.218.792-.3374 1.425-.3581l.74-.0234v-.1868c0-.2232-.06-.3867-.179-.4905-.115-.1038-.276-.1557-.483-.1557-.208 0-.41.0311-.607.0934-.198.0571-.395.1298-.592.218l-.382-.7863c.229-.1194.481-.2128.756-.2803.28-.0674.571-.1012.872-.1012zm.163 2.3823c-.374.0104-.633.0778-.778.2024-.146.1246-.218.288-.218.4905 0 .1764.051.3036.155.3814.104.0727.239.109.405.109.249 0 .459-.0726.631-.218.171-.1505.257-.3607.257-.6306v-.3503z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.158 39.2701h-1.1597v-3.3788h-1.0665c-.0519.6229-.1168 1.1549-.1947 1.596-.0726.436-.166.7915-.2802 1.0666-.109.2751-.2491.4775-.4204.6072-.1713.1246-.3815.1869-.6306.1869-.135 0-.2569-.0104-.3659-.0312-.109-.0207-.2076-.0519-.2959-.0934v-.9264c.0571.0207.1168.0389.1791.0545.0623.0155.1272.0233.1946.0233.0727 0 .1402-.0285.2024-.0856.0675-.0571.1298-.1583.1869-.3036.0623-.1454.1194-.3452.1713-.5995s.0986-.5735.1401-.9576c.0467-.3892.0882-.8589.1246-1.4091h3.2149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.9395 36.7244c0-.628.0778-1.16.2335-1.596.1557-.4412.4022-.7915.7396-1.051.3374-.2647.7785-.4438 1.3235-.5372.2751-.0467.5527-.0856.833-.1168.2855-.0363.5787-.0726.8797-.1089l.1324 1.012c-.1298.0156-.2725.0338-.4282.0545-.1557.0156-.314.0338-.4749.0545-.1557.0156-.3062.0338-.4515.0545-.1454.0208-.2777.0389-.3971.0545-.192.0312-.3607.0753-.506.1324-.1454.0519-.2673.1271-.3659.2257s-.1765.2336-.2336.4049c-.0519.166-.0856.3814-.1012.6461h.0545c.0623-.0986.1479-.1972.2569-.2958.1142-.0986.2543-.1817.4204-.2491.1661-.0675.3555-.1012.5683-.1012.3374 0 .6306.07.8798.2102.2491.1401.4411.3477.5761.6228.1349.2751.2024.6176.2024 1.0276 0 .4827-.0883.8849-.2647 1.2067-.1765.3218-.4204.5657-.7318.7318-.3114.1609-.6722.2414-1.0822.2414-.3114 0-.5942-.0571-.8486-.1713-.2543-.1142-.4723-.2829-.6539-.506-.1817-.2232-.3218-.4983-.4204-.8253-.0934-.3269-.1401-.7006-.1401-1.121zm2.1331 1.6816c.1661 0 .3088-.0364.4282-.109.1245-.0727.2206-.1921.288-.3581.0727-.1661.109-.3893.109-.6696 0-.3373-.0571-.6046-.1712-.8018-.109-.2025-.3011-.3037-.5762-.3037-.166 0-.3217.0416-.4671.1246-.1401.0778-.2595.1687-.3581.2725-.0986.0986-.1661.1842-.2024.2569 0 .2024.0156.3996.0467.5917.0312.1868.0831.3555.1557.506.0727.1505.1687.2699.2881.3581.1245.0882.2776.1324.4593.1324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.927 37.1371c0 .3529-.0493.6669-.148.942-.0934.2751-.2309.5086-.4126.7006-.1764.1869-.3918.3296-.6461.4282-.2544.0935-.5424.1402-.8642.1402-.2958 0-.5709-.0467-.8252-.1402-.2492-.0986-.4645-.2413-.6462-.4282-.1817-.192-.3244-.4255-.4282-.7006-.0986-.2751-.1479-.5891-.1479-.942 0-.4723.083-.8694.2491-1.1912.1661-.3269.4048-.5761.7163-.7473.3114-.1713.6799-.2569 1.1055-.2569.3996 0 .7525.0856 1.0587.2569.3063.1712.5476.4204.7241.7473.1764.3218.2647.7189.2647 1.1912zm-2.9351 0c0 .2802.0286.5164.0857.7084.0623.1869.1583.3296.288.4282.1298.0934.2985.1401.5061.1401s.3737-.0467.4982-.1401c.1298-.0986.2232-.2413.2803-.4282.0623-.192.0934-.4282.0934-.7084 0-.2803-.0311-.5138-.0934-.7007-.0571-.1868-.1505-.327-.2803-.4204-.1297-.0934-.2984-.1401-.506-.1401-.3062 0-.5294.1064-.6695.3192-.135.2076-.2025.5216-.2025.942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.7287 39.418c-.4516 0-.8408-.0856-1.1678-.2569-.327-.1765-.5787-.4126-.7552-.7084-.1712-.2959-.2569-.6229-.2569-.981h1.2301c0 .1765.0389.3322.1168.4671.083.1298.1972.2336.3425.3114.1453.0727.3114.109.4983.109.2076 0 .3814-.0415.5216-.1245.1453-.0883.2569-.205.3347-.3504.0779-.1505.1168-.3192.1168-.506 0-.192-.0389-.3607-.1168-.506-.0726-.1506-.1816-.2699-.3269-.3582-.1402-.0882-.3114-.1323-.5139-.1323-.1868 0-.3555.0389-.506.1168-.1505.0778-.2621.1764-.3348.2958h-1.1989l.2881-3.2075h3.4488v1.0899h-2.9428l.4905-.3269-.1713 1.8451-.2958-.0779c.1557-.1868.3425-.3425.5605-.4671.2232-.1298.5138-.1946.8719-.1946.4152 0 .7682.0856 1.0588.2569.2959.1661.5216.3918.6773.6773.1609.2802.2414.5942.2414.942v.1012c0 .3477-.0857.6721-.2569.9731-.1713.3011-.423.545-.7552.7319-.327.1868-.7266.2802-1.1989.2802z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.3301 39.2701 1.9385-3.0284.0156.1323-1.7906-2.7871h1.4013l1.1055 1.775h.1791l1.0899-1.775h1.3624l-1.7984 2.8027-.0233-.1246 2.0007 3.0051h-1.4091l-1.2923-2.0086h-.1869l-1.23 2.0086z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#62c03e"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 15.0273,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 15.0273,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 15.0273,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 15.0273,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 15.0273,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 15.0273,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 19.9551,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 19.9551,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 19.9551,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 19.9551,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 19.9551,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 24.8828,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 24.8828,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 24.8828,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 24.8828,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 29.8125,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 29.8125,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 29.8125,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 34.7383,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 34.7383,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 34.7383,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 34.7383,
    y: 21.6403
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 34.7383,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 34.7383,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 39.668,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 39.668,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 39.668,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 39.668,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 39.668,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 39.668,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 44.5957,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 44.5957,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 44.5957,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 44.5957,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 44.5957,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 44.5957,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 49.5234,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 49.5234,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 49.5234,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 49.5234,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 49.5234,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 49.5234,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 54.4512,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 54.4512,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 54.4512,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 54.4512,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 54.4512,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 54.4512,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 59.3789,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 59.3789,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 59.3789,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 59.3789,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 59.3789,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 59.3789,
    y: 35.5133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 64.3066,
    y: 12.4133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 64.3066,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 64.3066,
    y: 30.8933
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 64.3066,
    y: 17.0333
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 64.3066,
    y: 26.2733
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 64.3066,
    y: 35.5133
  })), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 29.8145,
    y: 21.6533
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 13.7266,
    y: 9.81824
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 21.8008,
    y: 11.8367
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 18.3398,
    y: 4.9165
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.004,
    rx: 2.002,
    width: 4.004,
    x: 26.7012,
    y: 6.93494
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl5);
export default __webpack_public_path__ + "static/media/sl5.9f9114836446effc470937b6d9c28097.svg";
export { ForwardRef as ReactComponent };